import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShield = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 20,
	viewBox: "0 0 19 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.37502 0C9.55471 0 9.73439 0.0390625 9.89845 0.113281L17.2539 3.23438C18.1133 3.59766 18.7539 4.44531 18.75 5.46875C18.7305 9.34375 17.1367 16.4336 10.4063 19.6562C9.75392 19.9688 8.99611 19.9688 8.34377 19.6562C1.6133 16.4336 0.019549 9.34375 1.77675e-05 5.46875C-0.00388848 4.44531 0.636736 3.59766 1.49611 3.23438L8.85549 0.113281C9.01564 0.0390625 9.19533 0 9.37502 0ZM9.37502 2.60938V17.375C14.7656 14.7656 16.2149 8.98828 16.25 5.52344L9.37502 2.60938Z",
		fill: "#0EAFAF"
	})
});
export default SvgShield;
